import React from "react";

const ErrorMessage = ({ errorMessage, errorType= "Error"}) => {

    return (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
            <strong className="font-bold">{errorType}!</strong>
            <span className="block sm:inline pl-1">{errorMessage}</span>
        </div>
    )

}

export default ErrorMessage;